/**
 * Constantes neutras compartilhadas pelas filter bars admin.
 *
 * Vivem aqui (e não em uma filter bar específica) para evitar acoplamento
 * cruzado entre componentes — qualquer filter bar pode importar daqui sem
 * depender de outra.
 */

export type AuditPeriod = '15m' | '1h' | '6h' | '24h' | '7d' | '30d';

export const AUDIT_PERIOD_OPTIONS: { value: AuditPeriod; label: string }[] = [
  { value: '15m', label: '15 min' },
  { value: '1h', label: 'Última hora' },
  { value: '6h', label: '6 horas' },
  { value: '24h', label: '24 horas' },
  { value: '7d', label: '7 dias' },
  { value: '30d', label: '30 dias' },
];

export const PAGE_SIZE_OPTIONS = [50, 100, 200] as const;

/**
 * Converte o período relativo em um timestamp ISO inicial (now - delta).
 * Usado pelos endpoints que esperam `start` em ISO-8601.
 */
export function auditPeriodToStart(period: AuditPeriod): string {
  const now = Date.now();
  const ms: Record<AuditPeriod, number> = {
    '15m': 15 * 60_000,
    '1h': 60 * 60_000,
    '6h': 6 * 60 * 60_000,
    '24h': 24 * 60 * 60_000,
    '7d': 7 * 24 * 60 * 60_000,
    '30d': 30 * 24 * 60 * 60_000,
  };
  return new Date(now - ms[period]).toISOString();
}
